module.exports = __webpack_public_path__ + "img/rollcall_6.5fdab0d0.png";